export const isTreezSSOEnabled =
    process.env.REACT_APP_AUTH_IDP_PROVIDER === "treez";
